import { Island } from '../../islands/island.class';
import { Kitchen } from '../kitchen.class';

/**
 * Re-binds every placed fuel appliance to the catalog row for the kitchen's current fuel.
 * A fuel appliance is stored as one row per fuel, so changing the kitchen's fuel has to move
 * each placed item onto its sibling row — unlike the old derived-suffix model, where the sku
 * recomputed itself on read. An item carrying its OWN fuelchoice is pinned and left alone.
 * @param kitchen Kitchen whose fuelchoice just changed
 * @returns count of panel items actually re-bound
 */
export const rebindFuelVariantsCfn = (kitchen: Kitchen): number => {
	const { fuelchoice } = kitchen;
	const islands: Array<Island> = [
		...(kitchen.design?.islands?.children ?? []),
		...(kitchen.design?.obstructions?.children ?? [])
	];

	let rebound = 0;
	islands.forEach((island) => {
		island.panels?.children?.forEach((panel) => {
			panel.panelItemGroups?.children?.forEach((group) => {
				group.items?.children?.forEach((panelItem) => {
					if (panelItem.item?.fuelchoice) return;
					if (panelItem.rebindFuelVariant(fuelchoice)) rebound++;
				});
			});
		});
	});

	return rebound;
};
